// Tooltip 'link copied'
function copyFunction() {
	const tooltip = document.getElementsByClassName('tooltiptext');
	for (var i = 0; i < tooltip.length; i++) {
		tooltip[i].innerHTML = 'Link copied!'; //+ copyText.value;
	}
}
// Tooltip revert content to 'copy link to clipboard'
function outFunc() {
	const tooltip = document.getElementsByClassName('tooltiptext');
	setTimeout(function () {
		for (var i = 0; i < tooltip.length; i++) {
			tooltip[i].innerHTML = 'Copy link to clipboard?';
		}
	}, 800);
}

document.addEventListener('DOMContentLoaded', function (event) {
	// Onload copy-link.js to clipboard script

	// Get all the elements that match the selector as arrays
	const copyTextareaBtn = Array.prototype.slice.call(
		document.querySelectorAll('.share_link')
	);
	const copyTextarea = Array.prototype.slice.call(
		document.querySelectorAll('.copy_share')
	);
	// Loop through the button array and set up event handlers for each element
	copyTextareaBtn.forEach(function (btn, idx) {
		btn.addEventListener('click', function () {
			// Get the textarea who's index matches the index of the button
			copyTextarea[idx].select();
			// Console message
			try {
				const msg = document.execCommand('copy')
					? 'successful'
					: 'unsuccessful';
				console.log('Copying text command was ' + msg);
			} catch (err) {
				console.log('Whoops, unable to copy');
			}
			btn.focus();
		});
	});
});
